module.exports = __webpack_public_path__ + "img/head_one.c91dbb37.png";